var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactivebullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2072_18628",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.2C0 0.984973 0.984974 0 2.2 0H7.2549C8.77098 0 10 1.22902 10 2.7451V5.06667C10 7.79127 7.79127 10 5.06667 10C2.26842 10 0 7.73158 0 4.93333V2.2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.2C0 0.984973 0.984974 0 2.2 0H7.2549C8.77098 0 10 1.22902 10 2.7451V5.06667C10 7.79127 7.79127 10 5.06667 10C2.26842 10 0 7.73158 0 4.93333V2.2Z",
    fill: "#D9D3CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 1H7.2549V-1H2.2V1ZM9 2.7451V5.06667H11V2.7451H9ZM1 4.93333V2.2H-1V4.93333H1ZM5.06667 9C2.82071 9 1 7.17929 1 4.93333H-1C-1 8.28386 1.71614 11 5.06667 11V9ZM9 5.06667C9 7.23899 7.23899 9 5.06667 9V11C8.34356 11 11 8.34356 11 5.06667H9ZM7.2549 1C8.21869 1 9 1.78131 9 2.7451H11C11 0.676738 9.32326 -1 7.2549 -1V1ZM2.2 -1C0.432689 -1 -1 0.432688 -1 2.2H1C1 1.53726 1.53726 1 2.2 1V-1Z",
    fill: "#D9D3CC",
    mask: "url(#path-1-inside-1_2072_18628)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivebullet);
export default __webpack_public_path__ + "static/media/inactivebullet.170a7153b80e43a187e778de1fc4e380.svg";
export { ForwardRef as ReactComponent };